import { JsonLd } from '../JsonLd';

interface ArticleLdProps {
  headline: string;
  url: string;
  image?: string;
  datePublished: string;
  dateModified?: string;
  author?: string;
}

export function ArticleLd({
  headline,
  url,
  image,
  datePublished,
  dateModified,
  author,
}: ArticleLdProps) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    url,
    image,
    datePublished,
    dateModified: dateModified ?? datePublished,
    author: { '@type': 'Organization', name: author ?? 'Solution Éco France' },
    publisher: {
      '@type': 'Organization',
      name: 'Solution Éco France',
      logo: { '@type': 'ImageObject', url: 'https://solutionecofrance.fr/logo.svg' },
    },
  };
  return <JsonLd schema={data} />;
}
